import { Route } from '@angular/router';

/** Auth routes used by ALL three apps — single Cognito pool, shared components. */
const coreAuthRoutes: Route[] = [
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('../pages/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('../pages/reset-password/reset-password').then((m) => m.ResetPassword),
  },
  {
    path: 'verify-2fa',
    loadComponent: () =>
      import('../pages/verify-2fa/verify-2fa').then((m) => m.Verify2fa),
  },
  {
    path: 'mfa-setup',
    loadComponent: () => import('../pages/mfa-setup/mfa-setup').then((m) => m.MfaSetup),
  },
];

/**
 * Auth routes for the unified `vantage` app — neutral subtitle, since one
 * login serves every user type and post-login routing is role-based.
 */
export const appAuthRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () => import('../pages/login/login').then((m) => m.Login),
    data: { subtitle: 'Sign in to your account' },
  },
  ...coreAuthRoutes,
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];

// oipAuthRoutes / subAuthRoutes / clientAuthRoutes / portalAuthRoutes (deprecated alias for
// subAuthRoutes) were leftovers from the four standalone `vantage_*` apps removed 2026-07-21 —
// `appAuthRoutes` above is the only auth route tree any app mounts (`app.routes.ts`). Deleted
// 2026-09-02 (R-12): zero importers repo-wide, confirmed by grep before removal (rule 30a).
